var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/component/x-file-list.ts
import "@adornis/base/utilTypes.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-empty-placeholder.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-grid.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { XSnackbar } from "@adornis/chemistry/elements/components/x-snackbar.js";
import "@adornis/chemistry/elements/components/x-stack.js";
import "@adornis/data-view/client/x-data-view.js";
import { View } from "@adornis/data-view/db/view.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import "@adornis/file-utils/db/files.js";
import "@adornis/forms/x-checkbox";
import "@adornis/forms/x-checkbox.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown-multiselection.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { DateTime } from "luxon";
import { combineLatest, debounceTime, filter, map, switchMap, takeUntil } from "rxjs";
import { queryFileExtensions } from "../../api/queryFileExtensions.js";
import { subscribeFilesPaginatedFiltered } from "../../api/subscribeFilesPaginated.js";
import { FileFilter } from "../../db/FileFilter.js";
import { FileListItem } from "../../db/FileListItem.js";
import { formatFileSize } from "../helper.js";
import { XFileChangeNameDialog } from "./x-file-change-name-dialog.js";
var XFileList = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.filter = new RXController(this, new FileFilter({}));
    this.fileClassSpecs = new RXController(this, void 0);
    this._fileExtensions = new RXController(
      this,
      this.fileClassSpecs.observable.pipe(
        filter(Boolean),
        map((specs) => specs.map((spec) => spec.fileClass._class)),
        switchMap((classNames) => queryFileExtensions(classNames)())
      )
    );
  }
  connectedCallback() {
    super.connectedCallback();
    combineLatest([
      this.fileClassSpecs.observable.pipe(
        filter(Boolean),
        map((fileClassSpecs) => {
          return fileClassSpecs.map((fileClassSpec) => fileClassSpec.fileClass._class);
        })
      ),
      this.filter.observable.pipe(
        filter(Boolean),
        switchMap((filter2) => filter2.whenChanging),
        debounceTime(200),
        takeUntil(this.disconnected)
      )
    ]).subscribe(([fileClassNames, fileFilter]) => {
      fileFilter.fileClassNames = fileClassNames;
    });
  }
  render() {
    if (!this.filter.value)
      this.filter.next(new FileFilter({}));
    const filter2 = this.filter.value;
    if (!filter2)
      return;
    return html`
      <x-flex space="md">
        <x-flex horizontal crossaxis-end space="md">
          <x-input
            placeholder="Suche.."
            flex
            clearable
            @value-changed=${(e) => {
      if (!filter2.fileName && !e.detail.value)
        return;
      if (filter2.fileName === e.detail.value)
        return;
      filter2.fileName = e.detail.value ?? null;
    }}
          ></x-input>
          <x-dropdown-multiselection
            ${css({ width: "100px" })}
            .selectables=${this._fileExtensions.value ?? []}
            @value-picked=${(e) => {
      const extensions = e.detail.value;
      filter2.fileExtensions = extensions;
    }}
          ></x-dropdown-multiselection>
        </x-flex>
        <x-flex horizontal crossaxis-start space="md">
          <x-checkbox
            label="Datei hat keine Verlinkungen"
            @value-changed=${(e) => {
      filter2.isWithoutTags = e.detail.value;
    }}
          ></x-checkbox>
        </x-flex>
        ${this._renderFiles()}
      </x-flex>
    `;
  }
  _renderFiles() {
    return html`
      <x-data-view
        .options=${{
      class: FileListItem,
      operation: subscribeFilesPaginatedFiltered,
      view: new View({
        filter: this.filter.value
      }),
      isEntryClickable: false,
      selectionSet: {
        _id: 1,
        file: { _id: 1, meta: { extension: 1, fileName: 1, size: 1 }, createdAt: 1 },
        tags: {
          _id: 1,
          fileID: 1,
          tagName: 1
        }
      },
      customColumns: [
        {
          customID: "Name",
          renderItem: (item) => {
            const file = item.file;
            return html`
                  <x-flex horizontal crossaxis-start ${css({ gap: "12px", padding: "4px 8px" })}>
                    <x-flex ${css({ padding: "4px", background: "#f9f9fb", color: "#333" })}>
                      ${this._getFileIcon(file)}
                    </x-flex>
                    <x-flex ${css({ gap: "8px" })}>
                      <x-text
                        ${css({
              fontSize: "16px"
            })}
                      >
                        ${file.meta?.fileName}
                      </x-text>

                      <x-text ${css({ fontSize: "12px" })}>
                        ${formatFileSize(file.meta?.size ?? 0)},
                        ${DateTime.fromJSDate(file.createdAt).toLocaleString(DateTime.DATETIME_MED)}
                      </x-text>

                      ${item.tags.length > 0 ? html`
                            <x-flex horizontal crossaxis-start wrap space="xxs">
                              ${item.tags.map(
              (tag) => html`
                                    <x-text
                                      ${css({
                fontSize: "10px",
                color: "#fff",
                background: this.colors.accent,
                borderRadius: "4px",
                padding: "2px 4px"
              })}
                                    >
                                      ${tag.tagName}
                                    </x-text>
                                  `
            )}
                            </x-flex>
                          ` : nothing}
                    </x-flex>
                  </x-flex>
                `;
          }
        },
        {
          customID: "Actions",
          columnWidth: "max-content",
          renderItem: (item) => {
            const file = item.file;
            const fileClassSpec = this.fileClassSpecs.value?.find(
              (fileClassSpec2) => fileClassSpec2.fileClass._class === file._class
            );
            if (!fileClassSpec)
              return html` unknown file class. How is this possible :O `;
            if (this.mode === "select")
              return html`
                    <x-checkbox
                      .value=${file._id === this.selectedFile?._id}
                      @value-picked=${() => {
                if (file._id === this.selectedFile?._id)
                  this.selectedFile = void 0;
                else
                  this.selectedFile = file;
                this.dispatchEvent(new CustomEvent("file-selected", { detail: { value: this.selectedFile } }));
              }}
                    >
                    </x-checkbox>
                  `;
            return html`
                  <x-flex ${css({ gap: "4px" })} horizontal wrap>
                    <x-icon
                      ${css({ cursor: "pointer", fontSize: "20px" })}
                      @click=${async () => {
              if (!item.file.meta)
                return;
              const oldFileName = item.file.meta.fileName;
              await XFileChangeNameDialog.changeName(oldFileName).then(async (newFileName) => {
                if (!newFileName || oldFileName === newFileName)
                  return;
                item.file.meta.fileName = newFileName;
                await item.file.save();
                XSnackbar.show("Dateiname gespeichert!");
              });
            }}
                    >
                      edit
                    </x-icon>
                    <x-icon
                      ${css({ cursor: "pointer", fontSize: "20px" })}
                      @click=${async () => {
              goTo(fileClassSpec.fileClass.getServeLink(file._id), { target: "_blank" });
            }}
                    >
                      open_in_new
                    </x-icon>
                    <x-icon
                      ${css({ cursor: "pointer", fontSize: "20px" })}
                      @click=${async () => {
              if (!await XDialog.confirm("Willst du diese Datei wirklich l\xF6schen?"))
                return;
              await fileClassSpec.fileClass.removeFile(file._id)().then(() => {
                return XSnackbar.show("Datei gel\xF6scht.").then(() => this.requestUpdate());
              });
            }}
                    >
                      delete
                    </x-icon>
                  </x-flex>
                `;
          }
        }
      ]
    }}
        ${css({ overflowY: "auto" })}
      ></x-data-view>
    `;
  }
  _getFileIcon(file) {
    let icon = "description";
    switch (file.meta?.extension) {
      case "pdf":
        icon = "picture_as_pdf";
        break;
      case "webp":
      case "jpg":
      case "jpeg":
      case "png":
        icon = "image";
        break;
      case "docx":
      case "doc":
        icon = "draft";
        break;
      case "json":
        icon = "file_json";
        break;
      case "exe":
      case "html":
        icon = "code";
        break;
      case "gif":
        icon = "gif_box";
        break;
      case "zip":
        icon = "folder_zip";
        break;
    }
    return html` <x-icon ${css({ fontSize: "24px" })}> ${icon} </x-icon> `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {}
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XFileList.prototype, "filter", 2);
__decorateClass([
  property({ attribute: false })
], XFileList.prototype, "fileClassSpecs", 2);
__decorateClass([
  property({ attribute: "mode" })
], XFileList.prototype, "mode", 2);
__decorateClass([
  property({ attribute: false })
], XFileList.prototype, "selectedFile", 2);
__decorateClass([
  state()
], XFileList.prototype, "_fileExtensions", 2);
XFileList = __decorateClass([
  customElement("x-file-list")
], XFileList);
export {
  XFileList
};
